<template>
  <div class="product">
    <banner title="产品中心" subtitle="PRODUCTS & SOLUTIONS" />
    <div class="product-section" v-loading="loading">
      <div class="product-section-content">
        <div class="product-grid" v-if="productList.length">
          <div class="product-card" v-for="item in productList" :key="item.Id">
            <div class="cover" v-lazy:background-image="$img(item.Img)"></div>
            <div class="body">
              <h3>{{ item.Title }}</h3>
              <p>{{ item.Summary || stripHtml(item.Content) }}</p>
              <router-link
                class="more"
                :to="{ name: 'productdetails', params: { id: item.Id } }"
              >
                查看详情 <i class="el-icon-arrow-right"></i>
              </router-link>
            </div>
          </div>
        </div>
        <div class="empty-tip" v-else-if="!loading">暂无产品，请先在后台添加。</div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";

export default {
  components: { Banner },
  data() {
    return {
      loading: true,
      productList: []
    };
  },
  mounted() {
    this.$http
      .get("Product")
      .then(response => {
        this.productList = response.data || [];
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  },
  methods: {
    stripHtml(html) {
      if (!html) return "";
      const text = String(html).replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
      return text.length > 70 ? text.slice(0, 70) + "..." : text;
    }
  }
};
</script>

<style lang="scss" scoped>
.product {
  width: 100%;
  background: linear-gradient(180deg, #14679f 0%, #0f4f7d 100%);
  padding-bottom: 40px;
}

.product-section-content {
  width: 1240px;
  max-width: calc(100% - 32px);
  margin: -28px auto 0;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 -8px 30px rgba(8, 28, 46, 0.12);
  position: relative;
  z-index: 1;
  padding: 36px 28px 40px;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

.product-card {
  border: 1px solid #e6eef5;
  border-radius: 14px;
  overflow: hidden;
  background: #fff;
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 14px 28px rgba(20, 103, 159, 0.12);
  }

  .cover {
    height: 180px;
    background: #e8eef4 center / cover no-repeat;
  }

  .body {
    padding: 18px 16px 16px;

    h3 {
      margin: 0;
      font-size: 18px;
      color: #17324a;
      line-height: 1.4;
    }

    p {
      margin: 10px 0 14px;
      min-height: 66px;
      color: #5d758a;
      font-size: 14px;
      line-height: 1.7;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .more {
      color: #1f6fab;
      text-decoration: none;
      font-size: 14px;
      display: inline-flex;
      align-items: center;
      gap: 2px;
    }
  }
}

.empty-tip {
  text-align: center;
  color: #7a93a8;
  padding: 80px 0;
}

@media (max-width: 960px) {
  .product-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .product-section-content {
    padding: 24px 14px 28px;
  }

  .product-grid {
    grid-template-columns: 1fr;
  }
}
</style>
